angular.module('unica_room.room_services')

.factory('RoomEditService', function ($http, getBaseApiURL) {

	var roomEditService = {};

	roomEditService.update = function (roomData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/room/update/' + roomData.id,
			data: roomData
		}).then(function(result) {

			if ( result ) {
				return result.data.room;
			}

		});

	};

	return roomEditService;
});